"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4045],{

/***/ 84045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.$0; },
/* harmony export */   "$_": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.$_; },
/* harmony export */   "$j": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.$j; },
/* harmony export */   "By": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.By; },
/* harmony export */   "F5": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.F5; },
/* harmony export */   "If": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.If; },
/* harmony export */   "L0": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.L0; },
/* harmony export */   "Sl": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.Sl; },
/* harmony export */   "VM": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.VM; },
/* harmony export */   "ZM": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.ZM; },
/* harmony export */   "_z": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__._z; },
/* harmony export */   "dp": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.dp; },
/* harmony export */   "ff": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.ff; },
/* harmony export */   "gn": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.gn; },
/* harmony export */   "h1": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.h1; },
/* harmony export */   "iz": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.iz; },
/* harmony export */   "l2": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.l2; },
/* harmony export */   "qY": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.qY; },
/* harmony export */   "rU": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.rU; },
/* harmony export */   "tw": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.tw; },
/* harmony export */   "u_": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.u_; },
/* harmony export */   "zx": function() { return /* reexport safe */ _src_landing__WEBPACK_IMPORTED_MODULE_0__.zx; }
/* harmony export */ });
/* harmony import */ var _src_landing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98226);



/***/ }),

/***/ 42200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31501);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61079);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89874);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35250);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65184);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19841);
/* harmony import */ var colord__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85799);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70079);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2177);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65443);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86650);
/* harmony import */ var _Spinner__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33550);












function getColors(color) {
    var opacity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (color === "transparent") {
        return {
            bg: "transparent",
            bgDark: "transparent",
            color: "currentColor"
        };
    }
    var bg = (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getColor */ .Lq)(color) || color;
    var bgd = (0,colord__WEBPACK_IMPORTED_MODULE_7__/* .colord */ .Vi)(bg).alpha(opacity);
    var text = opacity < 0.8 ? "currentColor" : bgd.isDark() ? "white" : "black";
    // const text = 'currentColor'
    var highlight = bgd.alpha(0.2).toRgbString();
    // console.log({ text, highlight, bg })
    return {
        text: text,
        highlight: highlight,
        bg: bgd.toRgbString()
    };
}
var Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(_param, ref) {
    var bg_ = _param.bg, bgDark_ = _param.bgDark, tmp = _param.as, _As = tmp === void 0 ? "button" : tmp, ghost = _param.ghost, _className = _param.className, className = _className === void 0 ? "" : _className, _type = _param.type, type = _type === void 0 ? "button" : _type, _icon = _param.icon, icon = _icon === void 0 ? "" : _icon, children = _param.children, isLoading = _param.isLoading, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, href = _param.href, _biggerOnHover = _param.biggerOnHover, biggerOnHover = _biggerOnHover === void 0 ? false : _biggerOnHover, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "bg",
        "bgDark",
        "as",
        "ghost",
        "className",
        "type",
        "icon",
        "children",
        "isLoading",
        "disabled",
        "href",
        "biggerOnHover"
    ]);
    // isLoading = true
    if (!bg_) {
        bg_ = "gray.500";
        bgDark_ = bgDark_ || "gray.300";
    }
    if (!bgDark_ && bg_) {
        bgDark_ = bg_;
    }
    var opacity = ghost ? 0.2 : 1;
    var light = getColors(bg_, opacity);
    var dark = getColors(bgDark_ || bg_, opacity);
    var As = href ? _Link__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .r : _As;
    var pseudo = ghost ? ":hover" : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(As, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        ref: ref,
        disabled: disabled || isLoading,
        href: href,
        type: type
    }, props), {
        className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
            [
                "26bc32a43c811f12",
                [
                    pseudo,
                    light.text,
                    light.bg,
                    pseudo,
                    dark.text,
                    dark.bg,
                    light.highlight,
                    dark.highlight,
                    light.bg,
                    dark.bg
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || (0,clsx__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)("px-[0.8em] !border-0 py-[0.5em] flex appearance-none gap-2 items-center", "justify-center font-medium tracking-wide rounded-md", "cursor-pointer colorAndBg active:opacity-50 transition-colors", biggerOnHover && !disabled && "biggerOnHover", disabled && "opacity-40 pointer-events-none", className) || ""),
        children: [
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "26bc32a43c811f12",
                dynamic: [
                    pseudo,
                    light.text,
                    light.bg,
                    pseudo,
                    dark.text,
                    dark.bg,
                    light.highlight,
                    dark.highlight,
                    light.bg,
                    dark.bg
                ],
                children: ".colorAndBg".concat(pseudo, ".__jsx-style-dynamic-selector{color:").concat(light.text, ";background-color:").concat(light.bg, "}.dark .colorAndBg").concat(pseudo, ".__jsx-style-dynamic-selector{color:").concat(dark.text, ";background-color:").concat(dark.bg, "}.biggerOnHover.__jsx-style-dynamic-selector{-webkit-box-shadow:0 0 0 0 ").concat(light.highlight, ";-moz-box-shadow:0 0 0 0 ").concat(light.highlight, ";box-shadow:0 0 0 0 ").concat(light.highlight, "}.dark .biggerOnHover.__jsx-style-dynamic-selector{-webkit-box-shadow:0 0 0 0 ").concat(dark.highlight, ";-moz-box-shadow:0 0 0 0 ").concat(dark.highlight, ";box-shadow:0 0 0 0 ").concat(dark.highlight, '}.biggerOnHover.__jsx-style-dynamic-selector{-webkit-animation:landingBlocksPulseAnimation 1.75s infinite cubic-bezier(.66,0,0,1);-moz-animation:landingBlocksPulseAnimation 1.75s infinite cubic-bezier(.66,0,0,1);-o-animation:landingBlocksPulseAnimation 1.75s infinite cubic-bezier(.66,0,0,1);animation:landingBlocksPulseAnimation 1.75s infinite cubic-bezier(.66,0,0,1)}@-webkit-keyframes landingBlocksPulseAnimation{to{-webkit-box-shadow:0 0 0 20px rgba(255,255,255,0);box-shadow:0 0 0 20px rgba(255,255,255,0)}}@-moz-keyframes landingBlocksPulseAnimation{to{-moz-box-shadow:0 0 0 20px rgba(255,255,255,0);box-shadow:0 0 0 20px rgba(255,255,255,0)}}@-o-keyframes landingBlocksPulseAnimation{to{box-shadow:0 0 0 20px rgba(255,255,255,0)}}@keyframes landingBlocksPulseAnimation{to{-webkit-box-shadow:0 0 0 20px rgba(255,255,255,0);-moz-box-shadow:0 0 0 20px rgba(255,255,255,0);box-shadow:0 0 0 20px rgba(255,255,255,0)}}.biggerOnHover.__jsx-style-dynamic-selector{-webkit-transition:-webkit-transform.15s;-moz-transition:-moz-transform.15s;-o-transition:-o-transform.15s;transition:-webkit-transform.15s;transition:-moz-transform.15s;transition:-o-transform.15s;transition:transform.15s;cursor:pointer;position:relative;z-index:1}.biggerOnHover.__jsx-style-dynamic-selector::after{content:"";background-color:').concat(light.bg, ";-webkit-transition:-webkit-transform.15s;-moz-transition:-moz-transform.15s;-o-transition:-o-transform.15s;transition:-webkit-transform.15s;transition:-moz-transform.15s;transition:-o-transform.15s;transition:transform.15s;-webkit-border-radius:7px;-moz-border-radius:7px;border-radius:7px;position:absolute;inset:0;z-index:-1}.dark .biggerOnHover.__jsx-style-dynamic-selector::after{background-color:").concat(dark.bg, "}.biggerOnHover.__jsx-style-dynamic-selector:hover::after,.biggerOnHover.__jsx-style-dynamic-selector:active::after{-webkit-transform:scaleX(1.03)scaleY(1.14);-moz-transform:scaleX(1.03)scaleY(1.14);-ms-transform:scaleX(1.03)scaleY(1.14);-o-transform:scaleX(1.03)scaleY(1.14);transform:scaleX(1.03)scaleY(1.14)}")
            }),
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                    [
                        "26bc32a43c811f12",
                        [
                            pseudo,
                            light.text,
                            light.bg,
                            pseudo,
                            dark.text,
                            dark.bg,
                            light.highlight,
                            dark.highlight,
                            light.bg,
                            dark.bg
                        ]
                    ]
                ]) + " " + "",
                children: icon
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                    [
                        "26bc32a43c811f12",
                        [
                            pseudo,
                            light.text,
                            light.bg,
                            pseudo,
                            dark.text,
                            dark.bg,
                            light.highlight,
                            dark.highlight,
                            light.bg,
                            dark.bg
                        ]
                    ]
                ]) + " " + "relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                            [
                                "26bc32a43c811f12",
                                [
                                    pseudo,
                                    light.text,
                                    light.bg,
                                    pseudo,
                                    dark.text,
                                    dark.bg,
                                    light.highlight,
                                    dark.highlight,
                                    light.bg,
                                    dark.bg
                                ]
                            ]
                        ]) + " " + (classnames__WEBPACK_IMPORTED_MODULE_4___default()("absolute inset-0 flex item-center justify-center colorAndBg", !isLoading && "hidden") || ""),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Spinner__WEBPACK_IMPORTED_MODULE_6__/* .Spinner */ .$, {})
                    }),
                    children
                ]
            })
        ]
    }));
});
Button.displayName = "Button";


/***/ }),

/***/ 86650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31501);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61079);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89874);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35250);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19841);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23185);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70079);







var Link = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(_param, ref) {
    var _href = _param.href, href = _href === void 0 ? "" : _href, onClick = _param.onClick, underline = _param.underline, children = _param.children, className = _param.className, iconBefore = _param.iconBefore, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "href",
        "onClick",
        "underline",
        "children",
        "className",
        "iconBefore"
    ]);
    var isExternal = href && !href.startsWith("/") && !href.startsWith("#");
    var Wrapper = !isExternal ? (next_link__WEBPACK_IMPORTED_MODULE_1___default()) : react__WEBPACK_IMPORTED_MODULE_2__.Fragment;
    if (isExternal && !props.target) {
        props.target = "_blank";
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, isExternal ? {} : {
        passHref: true,
        legacyBehavior: true,
        href: href
    }), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            ref: ref,
            href: href || "",
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("appearance-none max-w-max relative", "font-medium !border-white/0 cursor-pointer", iconBefore && "whitespace-nowrap", underline ? "underline" : "no-underline border-b-[2px] hover:!border-[color:currentColor] active:!border-[color:currentColor]", className),
            onClick: onClick && function(e) {
                if (!href) {
                    // otherwise it will trigger the link
                    e.preventDefault();
                }
                onClick && onClick(e);
            },
            style: {
                transition: "all 0.1s ease 0s"
            }
        }, props), {
            children: [
                iconBefore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "inline [&>*]:inline mr-1",
                    children: iconBefore
                }),
                children
            ]
        }))
    }));
});
Link.displayName = "Link";


/***/ }),

/***/ 12028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ PageContainer; },
/* harmony export */   "h": function() { return /* binding */ RootPageContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31501);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61079);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89874);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35250);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65443);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70079);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2177);








function PageContainer(_param) {
    var children = _param.children, _floatingElement = _param.floatingElement, floatingElement = _floatingElement === void 0 ? null : _floatingElement, _style = _param.style, style = _style === void 0 ? {} : _style, _dontContain = _param.dontContain, dontContain = _dontContain === void 0 ? false : _dontContain, _className = _param.className, className = _className === void 0 ? "" : _className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "floatingElement",
        "style",
        "dontContain",
        "className"
    ]);
    if (floatingElement) {
        dontContain = true;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            contain: dontContain ? "initial" : "paint"
        },
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("w-full max-w-full relative flex flex-col items-center "),
        children: [
            floatingElement && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("absolute flex flex-col items-center justify-center", "w-full z-0 inset-0"),
                children: floatingElement
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex flex-col w-full min-w-0 h-auto items-stretch", className),
                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                    // margin: '0 auto',
                    position: floatingElement ? "relative" : "static",
                    maxWidth: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .maxWidthWithPx */ .U1)()
                }, style)
            }, rest), {
                children: children
            }))
        ]
    });
}
function RootPageContainer(_param) {
    var children = _param.children, _style = _param.style, style = _style === void 0 ? {} : _style, _className = _param.className, className = _className === void 0 ? "" : _className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "style",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        style: {
            contain: "paint"
        },
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("relative min-h-full max-w-full items-stretch overflow-x-hidden", "flex-col flex space-y-[30px] md:space-y-[60px]", className)
    }, rest), {
        children: children
    }));
}


/***/ }),

/***/ 33550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Spinner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35250);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65184);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19841);



function Spinner(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "d35944268d6cdac0",
                children: '.spinner.jsx-d35944268d6cdac0{position:relative;pointer-events:none}.spinner.jsx-d35944268d6cdac0::after{content:"";position:absolute!important;top:-webkit-calc(50% - (1em/2));top:-moz-calc(50% - (1em/2));top:calc(50% - (1em/2));left:-webkit-calc(50% - (1em/2));left:-moz-calc(50% - (1em/2));left:calc(50% - (1em/2));display:block;width:1em;height:1em;border:solid currentColor;border-width:max(.1em,3px);opacity:.7;-webkit-border-radius:100%;-moz-border-radius:100%;border-radius:100%;border-right-color:transparent;border-top-color:transparent;-webkit-animation:spinAround 500ms infinite linear;-moz-animation:spinAround 500ms infinite linear;-o-animation:spinAround 500ms infinite linear;animation:spinAround 500ms infinite linear}@-webkit-keyframes spinAround{from{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-moz-keyframes spinAround{from{-moz-transform:rotate(0deg);transform:rotate(0deg)}to{-moz-transform:rotate(360deg);transform:rotate(360deg)}}@-o-keyframes spinAround{from{-o-transform:rotate(0deg);transform:rotate(0deg)}to{-o-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spinAround{from{-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(360deg);-moz-transform:rotate(360deg);-o-transform:rotate(360deg);transform:rotate(360deg)}}'
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "jsx-d35944268d6cdac0" + " " + ((0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("spinner w-5 h-5", className) || "")
            })
        ]
    });
}


/***/ }),

/***/ 98226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Uc": function() { return /* reexport */ BrowserWindow; },
  "zx": function() { return /* reexport */ Button/* Button */.z; },
  "iz": function() { return /* reexport */ Divider; },
  "By": function() { return /* reexport */ Faq; },
  "L0": function() { return /* reexport */ Feature; },
  "gZ": function() { return /* reexport */ FeaturesBlocks; },
  "gn": function() { return /* reexport */ FeedbackWithCrisp; },
  "$_": function() { return /* reexport */ Footer; },
  "tw": function() { return /* reexport */ GoogleLoginButton; },
  "VM": function() { return /* reexport */ Hero; },
  "ZM": function() { return /* reexport */ InlineCode; },
  "rU": function() { return /* reexport */ landing_Link/* Link */.r; },
  "u_": function() { return /* reexport */ Modal; },
  "l2": function() { return /* reexport */ NavBar; },
  "_z": function() { return /* reexport */ landing_PageContainer/* PageContainer */._; },
  "h1": function() { return /* reexport */ landing_PageContainer/* RootPageContainer */.h; },
  "$0": function() { return /* reexport */ Section; },
  "$j": function() { return /* reexport */ landing_Spinner/* Spinner */.$; },
  "dp": function() { return /* reexport */ utils/* formatBigNumber */.dp; },
  "F5": function() { return /* reexport */ utils/* refreshSsr */.F5; },
  "If": function() { return /* reexport */ utils/* useColorMode */.If; },
  "ff": function() { return /* reexport */ utils/* useColorModeValue */.ff; },
  "qY": function() { return /* reexport */ utils/* useDisclosure */.qY; },
  "Sl": function() { return /* reexport */ utils/* useThrowingFn */.Sl; }
});

// UNUSED EXPORTS: Accordion, Bullet, CloseButton, FeatureLink, GradientRect, HowItWorks, Icon, Input, PlayButton, PopOver, Pricing, TestimonialLogos, ToggleButton, VideoModal, beskarContext, getColor, maxWidthWithPx, rateLimit, useBeskar, useOnClickOutside, useSafeLayoutEffect

// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(35250);
// EXTERNAL MODULE: ../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(65443);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../beskar/src/landing/Bullet.tsx


function Bullet(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("max-w-max tracking-wider text-xs rounded truncate", "px-2 font-semibold bg-gray-600/10 py-[4px] dark:bg-white/10"),
        children: children
    });
}

// EXTERNAL MODULE: ../beskar/src/landing/Button.tsx
var Button = __webpack_require__(42200);
// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(70079);
;// CONCATENATED MODULE: ../beskar/src/landing/decorations/GradientRect.tsx





function lighter(c) {
    // const { colorMode } = useColorMode()
    // const isDark = colorMode === 'dark'
    var newColor = new Colord(c).alpha(0.06);
    return newColor.toRgbString();
}
function getCliPath(param) {
    var distortion = param.distortion;
    var isNegative = distortion < 0;
    distortion = Math.abs(distortion);
    var a = distortion * 100;
    var b = 100 - distortion * 100;
    if (isNegative) {
        return "polygon(0 ".concat(a, "%, 100% 0, 100% ").concat(b, "%, 0 100%)");
    }
    return "polygon(0% 0, 100% ".concat(a, "%, 100% 100%, 0 ").concat(b, "%)");
}
var GradientRect = function GradientRect(_param) {
    var _primary = _param.primary, primary = _primary === void 0 ? "#ffa257" : _primary, _secondary = _param.secondary, secondary = _secondary === void 0 ? "#ff71e0" : _secondary, _distortion = _param.distortion, distortion = _distortion === void 0 ? 0.3 : _distortion, rest = _object_without_properties(_param, [
        "primary",
        "secondary",
        "distortion"
    ]);
    primary = lighter(primary);
    secondary = lighter(secondary);
    var clipPath = getCliPath({
        distortion: distortion
    });
    return /*#__PURE__*/ _jsx("div", _object_spread({
        style: {
            clipPath: clipPath,
            width: "80%",
            maxWidth: 800,
            maxHeight: 300,
            height: "70%",
            background: "linear-gradient(45deg, ".concat(primary, " 30%, ").concat(secondary, " 60%)")
        }
    }, rest));
};

// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(31501);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(61079);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(89874);
// EXTERNAL MODULE: ../beskar/src/landing/PageContainer.tsx
var landing_PageContainer = __webpack_require__(12028);
;// CONCATENATED MODULE: ../beskar/src/landing/Divider.tsx







var Divider = function Divider(_param) {
    var _heading = _param.heading, heading = _heading === void 0 ? "" : _heading, animate = _param.animate, _className = _param.className, className = _className === void 0 ? "" : _className, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "heading",
        "animate",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_PageContainer/* PageContainer */._, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rest), {
        children: heading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("flex justify-center items-center space-x-4 flex-row", className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Line, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "font-medium tracking-widest flex-shrink-0 items-center",
                    children: heading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Line, {})
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Line, {})
    }));
};
function Line(porps) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,src_object_spread/* default */.Z)({
        className: "w-full flex-auto border-t"
    }, porps));
}

// EXTERNAL MODULE: ../beskar/src/utils.ts
var utils = __webpack_require__(2177);
;// CONCATENATED MODULE: ../beskar/src/landing/Faq.tsx








function Accordion(_param) {
    var children = _param.children, className = _param.className, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_PageContainer/* PageContainer */._, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: classnames_default()("section dark:text-gray-100 py-20", className)
    }, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "has-mw-4xl mx-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "space-y-6",
                    children: children
                })
            })
        })
    }));
}
function AccordionItem(param) {
    var heading = param.heading, content = param.content;
    var ref = (0,utils/* useDisclosure */.qY)(), toggle = ref.toggle, isOpen = ref.isOpen;
    var Icon = isOpen ? MaterialSymbolsKeyboardArrowUpRounded : MaterialSymbolsKeyboardArrowDownRounded;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: "flex flex-col space-y-4 bg-gray-200/50 backdrop-blur rounded dark:bg-gray-900/40 border p-6 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: toggle,
                className: "cursor-pointer flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-xl font-medium",
                        children: heading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-auto"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: toggle,
                        className: "rounded",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            className: "w-6 h-6"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("block", isOpen ? "" : "hidden"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("block whitespace-pre-wrap opacity-90 leading-relaxed"),
                    children: content
                })
            })
        ]
    });
}
var Faq = function Faq(param) {
    var items = param.items, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_PageContainer/* PageContainer */._, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion, {
            className: className,
            children: items.map(function(item, i) {
                return /*#__PURE__*/ (0,react.createElement)(AccordionItem, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
                    key: "item-".concat(i)
                }));
            })
        })
    });
};
function MaterialSymbolsKeyboardArrowDownRounded(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M12 14.975q-.2 0-.387-.075q-.188-.075-.313-.2l-4.6-4.6q-.275-.275-.275-.7q0-.425.275-.7q.275-.275.7-.275q.425 0 .7.275l3.9 3.9l3.9-3.9q.275-.275.7-.275q.425 0 .7.275q.275.275.275.7q0 .425-.275.7l-4.6 4.6q-.15.15-.325.212q-.175.063-.375.063Z"
        })
    }));
}
function MaterialSymbolsKeyboardArrowUpRounded(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M6.7 14.7q-.275-.275-.275-.7q0-.425.275-.7l4.6-4.6q.15-.15.325-.213q.175-.062.375-.062t.388.075q.187.075.312.2l4.6 4.6q.275.275.275.7q0 .425-.275.7q-.275.275-.7.275q-.425 0-.7-.275L12 10.8l-3.9 3.9q-.275.275-.7.275q-.425 0-.7-.275Z"
        })
    }));
}

// EXTERNAL MODULE: ../node_modules/.pnpm/@heroicons+react@1.0.6_react@18.2.0/node_modules/@heroicons/react/outline/esm/ArrowRightIcon.js
var ArrowRightIcon = __webpack_require__(7651);
// EXTERNAL MODULE: ../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(19841);
// EXTERNAL MODULE: ../beskar/src/landing/Link.tsx
var landing_Link = __webpack_require__(86650);
;// CONCATENATED MODULE: ../beskar/src/landing/Feature.tsx











function Feature(_param) {
    var heading = _param.heading, subheading = _param.subheading, _bullet = _param.bullet, bullet = _bullet === void 0 ? "" : _bullet, _image = _param.image, image = _image === void 0 ? null : _image, _flip = _param.flip, flip = _flip === void 0 ? false : _flip, _cta = _param.cta, cta = _cta === void 0 ? "" : _cta, _animate = _param.animate, animate = _animate === void 0 ? undefined : _animate, _direction = _param.direction, direction = _direction === void 0 ? "row" : _direction, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "heading",
        "subheading",
        "bullet",
        "image",
        "flip",
        "cta",
        "animate",
        "direction"
    ]);
    var dir = function() {
        if (direction === "row") {
            if (flip) {
                return "md:flex-row-reverse";
            }
            return "md:flex-row";
        }
        if (direction === "column") {
            if (flip) {
                return "md:flex-column-reverse";
            }
            return "md:flex-column";
        }
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_PageContainer/* PageContainer */._, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        dontContain: true
    }, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)("relative justify-between items-center max-w-full w-full", "flex flex-col ", dir),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "space-y-6 flex flex-col px-3 min-w-[300px] max-w-full flex-1",
                    children: [
                        bullet && /*#__PURE__*/ (0,jsx_runtime.jsx)(Bullet, {
                            children: bullet
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,clsx_m/* default */.Z)("text-4xl even:!mt-2 font-bold leading-relaxed "),
                            children: heading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " font-medium opacity-80 max-w-xl",
                            children: subheading
                        }),
                        cta && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: cta
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-12 h-12"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("flex flex-col flex-shrink-0 px-3 items-center flex-1", "max-w-[500px] min-w-[300px]"),
                    children: image
                })
            ]
        })
    }));
}
function FeatureLink(_param) {
    var children = _param.children, _hideArrow = _param.hideArrow, hideArrow = _hideArrow === void 0 ? false : _hideArrow, _className = _param.className, className = _className === void 0 ? "" : _className, _href = _param.href, href = _href === void 0 ? "" : _href, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "children",
        "hideArrow",
        "className",
        "href"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(landing_Link/* Link */.r, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        href: href,
        className: classnames_default()("flex items-center font-semibold space-x-2", className)
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            }),
            !hideArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightIcon/* default */.Z, {
                className: "mx-[10px] inline w-4 h-4 "
            })
        ]
    }));
}
Feature.Link = FeatureLink;

;// CONCATENATED MODULE: ../beskar/src/landing/Footer.tsx







function Footer(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, _columns = _param.columns, columns = _columns === void 0 ? {} : _columns, _justifyAround = _param.justifyAround, justifyAround = _justifyAround === void 0 ? false : _justifyAround, _businessName = _param.businessName, businessName = _businessName === void 0 ? "" : _businessName, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "className",
        "columns",
        "justifyAround",
        "businessName"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_PageContainer/* PageContainer */._, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,clsx_m/* default */.Z)("flex flex-col items-stretch space-y-10 lg:flex-row", "lg:space-x-10 lg:space-y-0 py-14 text-sm", justifyAround ? "justify-around" : "justify-between", className),
            children: Object.keys(columns).map(function(k, i) {
                var col = columns[k];
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "min-w-full space-y-6 lg:min-w-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "block w-auto font-medium text-left",
                            children: k
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "opacity-60 flex flex-col space-y-3",
                            children: Array.isArray(col) ? col.map(function(x, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "",
                                    children: x
                                }, i);
                            }) : col
                        })
                    ]
                }, i);
            })
        })
    }));
}

;// CONCATENATED MODULE: ../beskar/src/landing/Hero.tsx









function Hero(_param) {
    var heading = _param.heading, subheading = _param.subheading, cta = _param.cta, image = _param.image, _bullet = _param.bullet, bullet = _bullet === void 0 ? "" : _bullet, _fingerprint = _param.fingerprint, fingerprint = _fingerprint === void 0 ? "" : _fingerprint, _animate = _param.animate, animate = _animate === void 0 ? undefined : _animate, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "heading",
        "subheading",
        "cta",
        "image",
        "bullet",
        "fingerprint",
        "animate"
    ]);
    // useEffect(() => {
    //     console.log('Hero render')
    // })
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_PageContainer/* PageContainer */._, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)("flex items-center max-w-full flex-col", "md:flex-row leading-normal", image ? "justify-start md:space-x-8" : "justify-center"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("space-y-8 shrink-0 flex max-w-full flex-col text-center", image ? "md:max-w-[70%]" : "w-full", image ? "items-start" : "items-center", image ? "md:text-left" : "text-center"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)("flex flex-col w-full items-center space-y-4 ", image ? "md:items-start" : ""),
                            children: [
                                bullet && /*#__PURE__*/ (0,jsx_runtime.jsx)(Bullet, {
                                    children: bullet
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentIfString, {
                                    component: "h1",
                                    className: "block even:!mt-2 text-5xl font-semibold leading-normal",
                                    children: heading
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentIfString, {
                            component: "h2",
                            className: "text-2xl opacity-[0.78] leading-relaxed",
                            children: subheading
                        }),
                        cta && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("flex flex-col items-center max-w-full  w-full space-y-6", image && "md:items-start "),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "",
                                    children: cta
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "opacity-60 text-xs",
                                    children: fingerprint
                                })
                            ]
                        })
                    ]
                }),
                image && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("flex max-w-full flex-col md:flex-row flex-auto items-center "),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "ml-[40px] mt-[40px] flex-auto"
                        }),
                        image
                    ]
                })
            ]
        })
    }));
}
function ComponentIfString(_param) {
    var C = _param.component, children = _param.children, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "component",
        "children"
    ]);
    if (!children) {
        return null;
    }
    if (typeof children === "string") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(C, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rest), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rest), {
        children: [
            " ",
            children
        ]
    }));
}

;// CONCATENATED MODULE: ../beskar/src/landing/HowItWorks.tsx







function HowItWorks(_param) {
    var heading = _param.heading, subheading = _param.subheading, steps = _param.steps, _animate = _param.animate, animate = _animate === void 0 ? undefined : _animate, _className = _param.className, className = _className === void 0 ? "" : _className, rest = _object_without_properties(_param, [
        "heading",
        "subheading",
        "steps",
        "animate",
        "className"
    ]);
    return /*#__PURE__*/ _jsxs(PageContainer, _object_spread_props(_object_spread({
        className: className
    }, rest), {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: clsx("space-y-8 w-full flex-auto text-center items-center", "flex flex-col"),
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "text-3xl font-medium",
                        children: heading
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "max-w-2xl font-medium text-xl",
                        children: subheading
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: clsx("flex flex-col space-y-8 items-stretch flex-auto"),
                children: steps.map(function(step, i) {
                    return /*#__PURE__*/ _jsx(Step, _object_spread({
                        animate: animate,
                        number: i + 1,
                        flip: i % 2 !== 0
                    }, step), i);
                })
            })
        ]
    }));
}
var Step = function Step(_param) {
    var heading = _param.heading, subheading = _param.subheading, number = _param.number, image = _param.image, cta = _param.cta, decorativeHeading = _param.decorativeHeading, _flip = _param.flip, flip = _flip === void 0 ? false : _flip, _animate = _param.animate, animate = _animate === void 0 ? undefined : _animate, rest = _object_without_properties(_param, [
        "heading",
        "subheading",
        "number",
        "image",
        "cta",
        "decorativeHeading",
        "flip",
        "animate"
    ]);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        className: clsx("flex items-center justify-between gap-8", "flex-col", flip ? "md:flex-row-reverse" : "md:flex-row")
    }, rest), {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "min-w-[300px] max-w-[50%] flex-auto space-y-6 ",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-end opacity-40",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "opacity-70 text-7xl",
                                children: number
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "truncate max-w-[300px] font-semibold ",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "mx-2",
                                        children: " . "
                                    }),
                                    decorativeHeading !== null && decorativeHeading !== void 0 ? decorativeHeading : heading
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "opacity-90 font-medium leading-relaxed text-2xl",
                        children: heading
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "max-w-[90%] font-medium leading-relaxed opacity-[0.66] ",
                        children: subheading
                    }),
                    cta && /*#__PURE__*/ _jsx("div", {
                        className: "",
                        children: cta
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "min-w-[300px] shrink-0 max-w-[540px] flex-auto",
                children: image
            })
        ]
    }));
};

;// CONCATENATED MODULE: ../beskar/src/landing/InlineCode.tsx




function InlineCode(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("code", (0,src_object_spread/* default */.Z)({
        className: (0,clsx_m/* default */.Z)("text-red-500 dark:text-red-400 tracking-wide font-medium bg-gray-200", "mx-1 py-px px-1 rounded text-[85%] ", "dark:bg-gray-900/70", className)
    }, rest));
}

// EXTERNAL MODULE: ../node_modules/.pnpm/styled-jsx@5.0.7_react@18.2.0/node_modules/styled-jsx/style.js
var styled_jsx_style = __webpack_require__(65184);
var style_default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style);
// EXTERNAL MODULE: ../node_modules/.pnpm/react-dom@18.2.0_react@18.2.0/node_modules/react-dom/index.js
var react_dom = __webpack_require__(99581);
// EXTERNAL MODULE: ../node_modules/.pnpm/baby-i-am-faded@4.0.14_react@18.2.0/node_modules/baby-i-am-faded/esm/index.js + 1 modules
var esm = __webpack_require__(37833);
;// CONCATENATED MODULE: ../beskar/src/landing/Modal.tsx









esm/* Faded.defaultProps */.A.defaultProps = {
    cascadeIncrement: 80,
    duration: 120
};
function Modal(_param) {
    var tmp = _param.as, As = tmp === void 0 ? "div" : tmp, isOpen = _param.isOpen, onClose = _param.onClose, _className = _param.className, className = _className === void 0 ? "" : _className, content = _param.content, _disableAnimations = _param.disableAnimations, disableAnimations = _disableAnimations === void 0 ? false : _disableAnimations, _useDefaultContentStyle = _param.useDefaultContentStyle, useDefaultContentStyle = _useDefaultContentStyle === void 0 ? false : _useDefaultContentStyle, _initialFocus = _param.initialFocus, initialFocus = _initialFocus === void 0 ? null : _initialFocus, _maxWidth = _param.maxWidth, maxWidth = _maxWidth === void 0 ? "100%" : _maxWidth, _keepScrollBar = _param.keepScrollBar, keepScrollBar = _keepScrollBar === void 0 ? false : _keepScrollBar, _style = _param.style, style = _style === void 0 ? {} : _style, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "as",
        "isOpen",
        "onClose",
        "className",
        "content",
        "disableAnimations",
        "useDefaultContentStyle",
        "initialFocus",
        "maxWidth",
        "keepScrollBar",
        "style"
    ]);
    (0,react.useEffect)(function() {
        if (keepScrollBar) {
            return;
        }
        if (isOpen) {
            document.documentElement.style.overflow = "hidden";
        } else {
            document.documentElement.style.overflow = "";
        }
    }, [
        isOpen
    ]);
    (0,react.useEffect)(function() {
        var handler = function handler(event) {
            var ref;
            if ((event === null || event === void 0 ? void 0 : (ref = event.key) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === "escape") {
                event.preventDefault();
                onClose();
            }
        };
        document.addEventListener("keydown", handler);
        return function() {
            document.removeEventListener("keydown", handler);
        };
    }, []);
    var styles = (0,jsx_runtime.jsx)((style_default()), {
        id: "dd61b6f3c957de76",
        children: "@-webkit-keyframes zoomIn{from{opacity:0;-webkit-transform:scale(.9);transform:scale(.9)}to{opacity:1}}@-moz-keyframes zoomIn{from{opacity:0;-moz-transform:scale(.9);transform:scale(.9)}to{opacity:1}}@-o-keyframes zoomIn{from{opacity:0;-o-transform:scale(.9);transform:scale(.9)}to{opacity:1}}@keyframes zoomIn{from{opacity:0;-webkit-transform:scale(.9);-moz-transform:scale(.9);-o-transform:scale(.9);transform:scale(.9)}to{opacity:1}}@-webkit-keyframes simpleFade{from{opacity:0}to{opacity:1}}@-moz-keyframes simpleFade{from{opacity:0}to{opacity:1}}@-o-keyframes simpleFade{from{opacity:0}to{opacity:1}}@keyframes simpleFade{from{opacity:0}to{opacity:1}}"
    });
    if (!isOpen) {
        return styles;
    }
    return /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsxs)(As, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: "fixed inset-0 z-[1000] overflow-y-auto overflow-x-hidden"
    }, rest), {
        children: [
            styles,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Faded */.A, {
                disabled: disableAnimations,
                delay: 800,
                duration: 300,
                style: {
                    // transition:
                    //     'background 1s cubic-bezier(0.4, 0, 0.2, 1) !important',
                    backdropFilter: "blur(12px)",
                    // @ts-ignore
                    "-webkit-backdrop-filter": "blur(12px)",
                    background: "rgba(0, 0, 0, 0.1)"
                },
                onClick: function onClick(e) {
                    onClose();
                    e.stopPropagation();
                },
                animationName: "simpleFade",
                className: "fixed inset-0 bg-black bg-opacity-20"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Faded */.A, {
                duration: 220,
                timingFunction: "ease-in-out-quad",
                disabled: disableAnimations,
                animationName: "zoomIn",
                style: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, style), {
                    maxWidth: "min(".concat(maxWidth, ", 100vw - 60px)")
                }),
                className: (0,clsx_m/* default */.Z)("top-8 space-y-6 shadow-xl rounded-lg relative", "mx-auto min-w-0 isolate bg-transparent lg:top-14", className),
                children: useDefaultContentStyle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)("w-auto text-gray-700 space-y-8 rounded-lg ring-gray-100", "ring-1 py-4 px-2 md:px-8 min-w-0 justify-center items-stretch", "flex-col flex bg-white dark:text-gray-100 dark:ring-gray-700", "dark:bg-gray-800"),
                    children: content
                }) : content
            })
        ]
    })), document.body);
}
function CloseButton(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: (0,clsx_m/* default */.Z)("top-4 text-gray-600 shrink-0 rounded right-4", "p-1 bg-white/50 backdrop-blur appearance-none", "absolute dark:text-gray-400 dark:bg-gray-700/50", className),
        "aria-label": "Close",
        type: "button"
    }, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RiCloseFill, {
            className: "h-7 w-7"
        })
    }));
}
function RiCloseFill(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "m12 10.586l4.95-4.95l1.414 1.414l-4.95 4.95l4.95 4.95l-1.414 1.414l-4.95-4.95l-4.95 4.95l-1.414-1.414l4.95-4.95l-4.95-4.95L7.05 5.636z"
        })
    }));
}
Modal.CloseButton = CloseButton;

;// CONCATENATED MODULE: ../beskar/src/landing/NavBar.tsx











var NavBar = function NavBar(_param) {
    var logo = _param.logo, _navs = _param.navs, navs = _navs === void 0 ? [] : _navs, _className = _param.className, className = _className === void 0 ? "" : _className, style = _param.style, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "logo",
        "navs",
        "className",
        "style"
    ]);
    var ref = (0,utils/* useDisclosure */.qY)(), isOpen = ref.isOpen, onOpen = ref.onOpen, onClose = ref.onClose;
    var menuButtonStyle = {
        width: 32,
        height: 32
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(landing_PageContainer/* PageContainer */._, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        dontContain: true
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("flex w-full py-4", className),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "self-start",
                        children: logo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden md:flex items-center space-x-6 lg:space-x-8 font-medium ",
                        children: Array.isArray(navs) ? navs.map(function(x, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cursor-pointer",
                                children: x
                            }, i);
                        }) : navs
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "appearance-none block md:hidden",
                        onClick: onOpen,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {
                            style: (0,src_object_spread/* default */.Z)({}, menuButtonStyle)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                isOpen: isOpen,
                onClose: onClose,
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Faded */.A, {
                    className: classnames_default()("bg-gray-900/80 fixed w-screen h-screen inset-0", "pt-6 space-y-6 flex flex-col items-center text-white", "font-medium"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal.CloseButton, {
                            // style={{ right: 20, top: 20, ...menuButtonStyle }}
                            onClick: onClose
                        }),
                        Array.isArray(navs) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: navs.map(function(x, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "",
                                    children: x
                                }, i);
                            })
                        }) : navs
                    ]
                })
            })
        ]
    }));
};
var Menu = function Menu(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "28",
        height: "28",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinejoin: "round",
        strokeLinecap: "round"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "3",
                y1: "12",
                x2: "21",
                y2: "12"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "3",
                y1: "6",
                x2: "21",
                y2: "6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "3",
                y1: "18",
                x2: "21",
                y2: "18"
            })
        ]
    }));
};

// EXTERNAL MODULE: ../node_modules/.pnpm/@heroicons+react@1.0.6_react@18.2.0/node_modules/@heroicons/react/solid/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(40914);
;// CONCATENATED MODULE: ../beskar/src/landing/PopOver.tsx









var context = /*#__PURE__*/ (0,react.createContext)({
    isOpen: false,
    setOpen: function setOpen() {}
});
function PopOver(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, items = param.items, button = param.button;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var panel = (0,react.useRef)();
    (0,utils/* useOnClickOutside */.t$)(panel, function() {
        return setIsOpen(false);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context.Provider, {
        value: {
            isOpen: isOpen,
            setOpen: setIsOpen
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: panel,
            className: classnames_default()("relative "),
            children: [
                button,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Faded */.A, {
                    duration: 140,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Faded */.A, {
                        delay: 50,
                        animationName: "animateOnX",
                        cascade: true,
                        cascadeIncrement: 50,
                        className: classnames_default()("absolute p-4 space-y-4 w-max shadow-2xl ring-1", "ring-black ring-opacity-5 overflow-hidden max-w-screen-sm", "flex flex-col mt-3 transform -translate-x-1/2", "left-1/2 bg-white rounded-md dark:bg-gray-700", className, isOpen ? "!block" : "!hidden"),
                        children: items
                    }, isOpen ? "open" : "hidden")
                }, isOpen ? "open" : "hidden")
            ]
        })
    });
}
var PopOver_Button = /*#__PURE__*/ (0,react.forwardRef)(function Button(param, ref) {
    var children = param.children;
    var _$ref = (0,react.useContext)(context), isOpen = _$ref.isOpen, setOpen = _$ref.setOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        ref: ref,
        onClick: function onClick() {
            return setOpen(function(isOpen) {
                return !isOpen;
            });
        },
        className: classnames_default()("group rounded-md inline-flex items-center font-medium", "hover:text-opacity-100 focus:outline-none", "focus-visible:ring-2 focus-visible:ring-white", "focus-visible:ring-opacity-75"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                className: classnames_default()("ml-1 pt-1 h-6 w-6 flex-shrink-0 transition ease-in-out", "duration-150 group-hover:text-opacity-80"),
                "aria-hidden": "true"
            })
        ]
    });
});
PopOver.Button = PopOver_Button;
var Item = /*#__PURE__*/ (0,react.forwardRef)(function Item(_param, ref) {
    var title = _param.title, _description = _param.description, description = _description === void 0 ? "" : _description, _icon = _param.icon, icon = _icon === void 0 ? null : _icon, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "title",
        "description",
        "icon"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        ref: ref,
        className: classnames_default()("flex items-center p-2 transition duration-150", "ease-in-out rounded-lg !bg-opacity-60 cursor-pointer", "active:bg-warmGray-200 dark:active:bg-gray-500", "focus:outline-none hover:bg-warmGray-200 dark:hover:bg-gray-500", "focus-visible:ring focus-visible:ring-orange-500", "focus-visible:ring-opacity-50")
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("flex items-center justify-center flex-shrink-0", "w-12 h-12"),
                children: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ml-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "font-medium",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-sm opacity-60",
                        children: description
                    })
                ]
            })
        ]
    }));
});
PopOver.Item = Item;

// EXTERNAL MODULE: ../beskar/src/landing/Spinner.tsx
var landing_Spinner = __webpack_require__(33550);
// EXTERNAL MODULE: ../node_modules/.pnpm/next-auth@4.12.2_nitggutgekmxcbakccyp3sboiq/node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(68278);
// EXTERNAL MODULE: ../node_modules/.pnpm/next@12.3.2_biqbaboplfbrettd7655fr4n2y/node_modules/next/router.js
var router = __webpack_require__(77577);
// EXTERNAL MODULE: ../node_modules/.pnpm/nprogress@0.2.0/node_modules/nprogress/nprogress.js
var nprogress = __webpack_require__(27811);
;// CONCATENATED MODULE: ../beskar/src/landing/Pricing.tsx



















// const getSubscriptionMemoized = memoize(getSubscription, { isPromise: true })
function Pricing(_param) {
    var refetchSubscription = function refetchSubscription() {
        setSubscription(undefined);
        getSubscription().then(function(subscription) {
            if (subscription) {
                setSubscription(subscription);
            }
        });
    };
    var products = _param.products, _animate = _param.animate, animate = _animate === void 0 ? false : _animate, _className = _param.className, className = _className === void 0 ? "" : _className, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, onCheckout = _param.onCheckout, _promptLogin = _param.promptLogin, promptLogin = _promptLogin === void 0 ? function promptLogin() {} : _promptLogin, updatePlan = _param.updatePlan, getSubscription = _param.getSubscription, productDetails = _param.productDetails, needMoreEmail = _param.needMoreEmail, manageSubscriptionHref = _param.manageSubscriptionHref, _pricesCurrency = _param.pricesCurrency, pricesCurrency = _pricesCurrency === void 0 ? "USD" : _pricesCurrency, _allowYearlyBilling = _param.allowYearlyBilling, allowYearlyBilling = _allowYearlyBilling === void 0 ? true : _allowYearlyBilling, passthrough = _param.passthrough, rest = _object_without_properties(_param, [
        "products",
        "animate",
        "className",
        "isLoading",
        "onCheckout",
        "promptLogin",
        "updatePlan",
        "getSubscription",
        "productDetails",
        "needMoreEmail",
        "manageSubscriptionHref",
        "pricesCurrency",
        "allowYearlyBilling",
        "passthrough"
    ]);
    var ref = useState(), subscription = ref[0], setSubscription = ref[1];
    var ref1 = useSession(), status = ref1.status, session = ref1.data;
    var ref2 = useState("month"), billingInterval = ref2[0], setBillingInterval = ref2[1];
    useEffect(function() {
        void _async_to_generator(function() {
            var subscription;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (status !== "authenticated") {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            getSubscription()
                        ];
                    case 1:
                        subscription = _state.sent();
                        if (subscription) {
                            setSubscription(subscription);
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        status
    ]);
    var FadedComponent = animate ? Faded : "div";
    return /*#__PURE__*/ _jsxs(PageContainer, _object_spread_props(_object_spread({
        id: "pricing",
        style: {
            // @ts-ignore
            "--page-max-width": "100vw"
        },
        className: classNames("relative self-center mx-auto", className)
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "relative sm:flex sm:flex-col sm:align-center",
                children: allowYearlyBilling && /*#__PURE__*/ _jsx(BillingIntervalSelect, {
                    billingInterval: billingInterval,
                    setBillingInterval: setBillingInterval
                })
            }),
            /*#__PURE__*/ _jsxs(FadedComponent, _object_spread_props(_object_spread({}, animate && {
                cascade: true,
                whenInView: true,
                triggerOnce: true
            }), {
                style: {
                    minHeight: "500px"
                },
                className: classNames("relative flex flex-col items-center justify-center", "mt-12 space-y-8 lg:mx-auto lg:items-stretch", "lg:flex-row lg:space-x-6 lg:space-y-0"),
                children: [
                    isLoading && /*#__PURE__*/ _jsx(Spinner, {}),
                    !isLoading && products && products.sort(function(a, b) {
                        var ref, ref1, ref2, ref3;
                        return ((ref1 = a === null || a === void 0 ? void 0 : (ref = a.prices) === null || ref === void 0 ? void 0 : ref.find(function(one) {
                            return one.currency === pricesCurrency;
                        })) === null || ref1 === void 0 ? void 0 : ref1.unitAmount) - ((ref3 = b === null || b === void 0 ? void 0 : (ref2 = b.prices) === null || ref2 === void 0 ? void 0 : ref2.find(function(one) {
                            return one.currency === pricesCurrency;
                        })) === null || ref3 === void 0 ? void 0 : ref3.unitAmount);
                    }).filter(function(x) {
                        if (status === "authenticated") {
                            return x.prices.every(function(p) {
                                return p.unitAmount > 0;
                            });
                        }
                        return true;
                    }).map(function(product) {
                        var ref;
                        var price = product === null || product === void 0 ? void 0 : (ref = product.prices) === null || ref === void 0 ? void 0 : ref.find(function(one) {
                            return one.currency === pricesCurrency;
                        });
                        if (!price) {
                            return null;
                        }
                        if (product.billing_type !== billingInterval) {
                            return null;
                        }
                        var details = productDetails.find(function(x) {
                            return x.paddleId === product.paddleId;
                        });
                        return /*#__PURE__*/ _jsx(SubscriptionPlan, {
                            passthrough: passthrough,
                            description: details === null || details === void 0 ? void 0 : details.description,
                            updatePlan: updatePlan,
                            refetchSubscription: refetchSubscription,
                            promptLogin: promptLogin,
                            features: (details === null || details === void 0 ? void 0 : details.features) || [],
                            contactUs: details === null || details === void 0 ? void 0 : details.contactLink,
                            onCheckout: onCheckout,
                            product: product,
                            price: price,
                            subscription: subscription
                        }, product.paddleId);
                    })
                ]
            })),
            subscription && manageSubscriptionHref ? /*#__PURE__*/ _jsx(FadedComponent, {
                className: "text-center h-[2em] mt-10",
                children: /*#__PURE__*/ _jsx(Link, {
                    href: manageSubscriptionHref,
                    children: "Manage subscription"
                })
            }) : !!needMoreEmail && /*#__PURE__*/ _jsxs(FadedComponent, {
                className: "text-center opacity-80 text-sm h-[2em] mt-10",
                children: [
                    "Need more?",
                    " ",
                    /*#__PURE__*/ _jsx(Link, {
                        href: "mailto:".concat(needMoreEmail, "?subject=").concat(encodeURIComponent("Need a custom plan")),
                        children: "Contact me"
                    })
                ]
            })
        ]
    }));
}
function BillingIntervalSelect(param) {
    var billingInterval = param.billingInterval, setBillingInterval = param.setBillingInterval;
    return /*#__PURE__*/ _jsxs("div", {
        className: classNames("relative self-center bg-gray-200 rounded-lg", "p-0.5 flex"),
        children: [
            /*#__PURE__*/ _jsx("button", {
                onClick: function onClick() {
                    return setBillingInterval("month");
                },
                type: "button",
                className: classNames("relative w-1/2 py-2 text-sm font-medium text-gray-700", "whitespace-nowrap rounded-lg sm:px-8 sm:w-auto", "focus:z-10 focus:ring-2 focus:outline-none", {
                    "bg-white border-gray-200 shadow-sm rounded-md text-gray-900": billingInterval === "month",
                    "bg-transparent": billingInterval !== "month"
                }),
                children: "Monthly billing"
            }),
            /*#__PURE__*/ _jsx("button", {
                onClick: function onClick() {
                    return setBillingInterval("year");
                },
                type: "button",
                className: classNames("relative w-1/2 bg-white py-2 text-sm font-medium", "text-gray-700 whitespace-nowrap rounded-lg", "sm:px-8 sm:w-auto focus:z-10 focus:ring-2 focus:outline-none", {
                    "bg-white border-gray-200 shadow-sm rounded-md text-gray-900": billingInterval === "year",
                    "bg-transparent": billingInterval !== "year"
                }),
                children: "Yearly billing"
            })
        ]
    });
}
function SubscriptionPlan(param) {
    var product = param.product, price = param.price, subscription = param.subscription, description = param.description, refetchSubscription = param.refetchSubscription, onCheckout = param.onCheckout, _contactUs = param.contactUs, contactUs = _contactUs === void 0 ? "" : _contactUs, features = param.features, promptLogin = param.promptLogin, updatePlan = param.updatePlan, style = param.style, passthrough = param.passthrough;
    var ref;
    var router = useRouter();
    var ref1 = useSession(), status = ref1.status, session = ref1.data;
    var ref2 = useThrowingFn({
        fn: updatePlan,
        errorMessage: "Failed to update plan",
        successMessage: "Updated plan!"
    }), changePlan = ref2.fn, isLoading = ref2.isLoading;
    var handlePricingClick = function() {
        var _ref = _async_to_generator(function(paddleId) {
            var ref, pass, ref1;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (status !== "authenticated" && promptLogin) {
                            return [
                                2,
                                promptLogin()
                            ];
                        }
                        if (!(session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.id)) {
                            throw new Error("User ID is missing");
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            7,
                            8
                        ]);
                        if (!subscription) return [
                            3,
                            5
                        ];
                        // clear subscription cache
                        // getSubscriptionMemoized.cache.keys.length = 0
                        // getSubscriptionMemoized.cache.values.length = 0
                        if (!confirm("Changing plan will remove any existing coupons, continue?")) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            changePlan({
                                subscriptionId: subscription.paddleSubscriptionId,
                                planId: paddleId
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            new Promise(function(resolve) {
                                return setTimeout(resolve, 100);
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            4,
                            refetchSubscription()
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2
                        ];
                    case 5:
                        NProgress.start();
                        pass = passthrough();
                        Paddle.Checkout.open({
                            product: paddleId,
                            email: session.user.email,
                            passthrough: typeof pass === "string" ? pass : JSON.stringify(pass),
                            successCallback: function successCallback() {
                                toast.success("Created plan", {
                                    position: "top-center"
                                });
                                refetchSubscription();
                            }
                        });
                        _state.label = 6;
                    case 6:
                        return [
                            3,
                            8
                        ];
                    case 7:
                        if (onCheckout) {
                            onCheckout({
                                isChangePlan: Boolean(subscription),
                                userId: session === null || session === void 0 ? void 0 : (ref1 = session.user) === null || ref1 === void 0 ? void 0 : ref1.id
                            });
                        }
                        return [
                            7
                        ];
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePricingClick(paddleId) {
            return _ref.apply(this, arguments);
        };
    }();
    var alreadyUsingThisPlan = product.paddleId === (subscription === null || subscription === void 0 ? void 0 : subscription.productId);
    var buyMessage = useMemo(function() {
        if (price.unitAmount == 0) {
            return "Get started";
        }
        if (alreadyUsingThisPlan) {
            return "Current plan";
        }
        if (subscription) {
            if (price.unitAmount > Number(subscription.unit_price) * 100) {
                return "Upgrade";
            }
            return "Downgrade";
        }
        if (!!product.trial_days) {
            return "Start free trial";
        }
        return "Buy ".concat(product.name);
    }, [
        subscription,
        price
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        style: style,
        className: classNames("border border-gray-200 rounded-lg shadow-sm", "divide-y divide-gray-200 bg-white max-w-sm w-[280px] xl:w-[310px]"),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "p-6 flex flex-col h-[300px]",
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: "text-lg font-medium leading-6 text-gray-900",
                        children: (ref = product.name) === null || ref === void 0 ? void 0 : ref.split("-")[0]
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "h-12 mt-4 text-sm font-medium tracking-wide text-gray-500",
                        children: description || "."
                    }),
                    contactUs ? /*#__PURE__*/ _jsx("p", {
                        className: "mt-9 text-center text-lg text-gray-500"
                    }) : /*#__PURE__*/ _jsxs("p", {
                        className: "mt-8",
                        children: [
                            /*#__PURE__*/ _jsxs("span", {
                                className: "text-4xl font-extrabold tracking-wide text-gray-900",
                                children: [
                                    "$",
                                    Number(product.billing_type === "year" ? price.unitAmount / 12 / 100 : price.unitAmount / 100).toFixed(0)
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ _jsx("span", {
                                className: "text-base font-medium text-gray-500",
                                children: "/mo"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex-1"
                    }),
                    contactUs ? /*#__PURE__*/ _jsx(BuyButton, {
                        children: /*#__PURE__*/ _jsx("a", {
                            href: contactUs,
                            children: "Contact"
                        })
                    }) : /*#__PURE__*/ _jsx(BuyButton, {
                        onClick: function onClick() {
                            price.unitAmount == 0 ? promptLogin() : handlePricingClick(product.paddleId);
                        },
                        "aria-label": "buy ".concat(product.name),
                        disabled: alreadyUsingThisPlan,
                        children: isLoading ? "Loading..." : buyMessage
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: classNames("text-xs text-center mt-3 font-medium text-gray-500", "min-h-[1.2em]"),
                        children: !!product.trial_days && /*#__PURE__*/ _jsxs("span", {
                            className: "",
                            children: [
                                product.trial_days,
                                " days free trial"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "px-6 pt-6 pb-8",
                children: [
                    /*#__PURE__*/ _jsx("h3", {
                        className: classNames("text-sm font-medium tracking-wide text-gray-400", "uppercase"),
                        children: "What's included"
                    }),
                    /*#__PURE__*/ _jsx("ul", {
                        role: "list",
                        className: "mt-6 space-y-4 text-sm font-medium",
                        children: features.map(function(feature) {
                            return /*#__PURE__*/ _jsxs("li", {
                                className: "flex space-x-3",
                                children: [
                                    /*#__PURE__*/ _jsx(CheckIcon, {
                                        className: "flex-shrink-0 w-5 h-5 text-emerald-600",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "text-gray-600 ",
                                        children: feature
                                    })
                                ]
                            }, feature);
                        })
                    })
                ]
            })
        ]
    });
}
function BuyButton(_param) {
    var children = _param.children, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = _object_without_properties(_param, [
        "children",
        "disabled"
    ]);
    return /*#__PURE__*/ _jsx("button", _object_spread_props(_object_spread({
        // variant='unstyled'
        className: classNames("block w-full py-2 mt-8 text-sm font-semibold text-center", "text-white bg-gray-900 border border-black rounded-md", "hover:cursor-pointer active:bg-white active:text-black", disabled ? "opacity-50 pointer-events-none" : "")
    }, rest), {
        children: children
    }));
}

;// CONCATENATED MODULE: ../beskar/src/landing/Section.tsx






var Section = function Section(_param) {
    var children = _param.children, bg = _param.bg, className = _param.className, tmp = _param.degree, _degree = tmp === void 0 ? 2 : tmp, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "children",
        "bg",
        "className",
        "degree"
    ]);
    // const { bg } = rest
    var degreeStr = _degree.toFixed(1);
    var styles = {
        background: bg,
        width: "100%",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        position: "absolute",
        transform: "skewY(".concat(degreeStr, "deg)"),
        transformOrigin: "center"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: "relative"
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: (0,src_object_spread/* default */.Z)({}, styles)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, styles), {
                    transform: "skewY(".concat(degreeStr + 2, "deg)"),
                    opacity: 0.2,
                    transformOrigin: "60%"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: (0,src_object_spread/* default */.Z)({
                    transform: "skewY(".concat(degreeStr + 3, "deg)"),
                    transformOrigin: "70%",
                    opacity: 0.1
                }, styles)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("flex flex-col items-stretch w-full max-w-full", className),
                children: children
            })
        ]
    }));
};

;// CONCATENATED MODULE: ../beskar/src/landing/TestimonialLogos.tsx





function TestimonialLogos(param) {
    var items = param.items, _invert = param.invert, invert = _invert === void 0 ? false : _invert, className = param.className;
    return /*#__PURE__*/ _jsx(PageContainer, {
        children: /*#__PURE__*/ _jsx("div", {
            className: clsx("flex flex-col justify-around flex-1 items-center ", "md:flex-row gap-14", className),
            children: items.map(function(x) {
                var LinkOrNot = x.href ? "a" : "div";
                return /*#__PURE__*/ _jsx(LinkOrNot, _object_spread_props(_object_spread({
                    style: _object_spread({
                        opacity: x.opacity
                    }, invert && {
                        filter: "invert()"
                    })
                }, x.href && {
                    href: x.href || "",
                    target: "_blank"
                }), {
                    className: "block appearance-none",
                    children: /*#__PURE__*/ _jsx("img", {
                        src: x.src,
                        alt: "logo",
                        className: "max-w-[180px] max-h-[40px]"
                    })
                }), x.src);
            })
        })
    });
}

;// CONCATENATED MODULE: ../beskar/src/landing/VideoModal.tsx









function VideoModal(param) {
    var youtubeVideoId = param.youtubeVideoId, _aspectRatio = param.aspectRatio, aspectRatio = _aspectRatio === void 0 ? 16 / 9 : _aspectRatio, _className = param.className, className = _className === void 0 ? "" : _className, _button = param.button, button = _button === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayButton, {
        className: ""
    }) : _button;
    var ref = (0,utils/* useDisclosure */.qY)(), isOpen = ref.isOpen, onClose = ref.onClose, onOpen = ref.onOpen;
    var src = "https://www.youtube.com/embed/".concat(youtubeVideoId, "?vq=hd1080");
    var padding = 1 / aspectRatio * 100;
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                className: "!max-w-full mx-2 md:mx-20 " + className,
                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)("flex bg-white/20 text-white w-full flex-col items-center justify-center", "p-8 space-y-8"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal.CloseButton, {
                            onClick: onClose
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative w-full max-h-[calc(80vh)]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        paddingTop: padding + "%"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                    title: "video",
                                    src: src,
                                    height: "1080",
                                    // width='1920'
                                    frameBorder: 0,
                                    // loading='lazy'
                                    allowFullScreen: true,
                                    allowTransparency: true,
                                    onLoad: function onLoad() {
                                        return setIsLoading(false);
                                    },
                                    className: "absolute bg-transparent rounded-lg inset-0 w-full h-full max-w-full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)("absolute inset-0 flex items-center justify-center", isLoading ? "block" : "hidden"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_Spinner/* Spinner */.$, {
                                        className: "text-5xl text-gray-600"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                isOpen: isOpen,
                onClose: onClose
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: onOpen,
                className: "",
                children: button
            })
        ]
    });
}
function PlayButton(_param) {
    var className = _param.className, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: "appearance-none ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            viewBox: "0 0 24 24",
            className: (0,clsx_m/* default */.Z)("h-28 hover:scale-110 transition-transform ", className)
        }, props), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "currentColor",
                d: "M9.525 18.025q-.5.325-1.013.037Q8 17.775 8 17.175V6.825q0-.6.512-.888q.513-.287 1.013.038l8.15 5.175q.45.3.45.85t-.45.85Z"
            })
        }))
    });
}
VideoModal.PLayButton = PlayButton;

;// CONCATENATED MODULE: ../beskar/src/landing/BrowserWindow.tsx


function BrowserWindow(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className, _host = param.host, host = _host === void 0 ? "example.com" : _host;
    var dot = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: classnames_default()("rounded-full bg-gray-600 dark:bg-gray-600 w-[0.7em]", "h-[0.7em]")
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
        className: classnames_default()("rounded-b-md relative max-w-full h-auto z-[1]", "shadow-[0_2.75rem_3.5rem_-2rem_rgb(45_55_75_/_20%),_0_0_5rem_-2rem_rgb(45_55_75_/_15%)]", "dark:shadow-[0_2.75rem_3.5rem_-2rem_rgb(0_0_0_/_20%),_0_0_5rem_-2rem_rgb(0_0_0_/_15%)]", "text-xs", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("rounded-t-md relative py-2 px-24 items-center", "flex bg-gray-800 dark:bg-gray-700"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("top-0 left-4 items-center h-full flex absolute", "gap-[0.5em]"),
                        children: [
                            dot,
                            dot,
                            dot
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("w-full truncate text-gray-400 justify-center", "items-center h-full flex bg-gray-700 dark:text-gray-400", "dark:bg-gray-600"),
                        children: host
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rounded-b-md flex flex-col overflow-hidden",
                children: children
            })
        ]
    });
}

;// CONCATENATED MODULE: ../beskar/src/landing/Toggle.tsx





function ToggleButton(_param) {
    var heading = _param.heading, content = _param.content, _pl = _param.pl, pl = _pl === void 0 ? "24px" : _pl, _className = _param.className, className = _className === void 0 ? "" : _className, _initialIsOpen = _param.initialIsOpen, initialIsOpen = _initialIsOpen === void 0 ? false : _initialIsOpen, rest = _object_without_properties(_param, [
        "heading",
        "content",
        "pl",
        "className",
        "initialIsOpen"
    ]);
    var ref = useDisclosure(initialIsOpen), isOpen = ref.isOpen, toggle = ref.toggle;
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        className: className
    }, rest), {
        children: [
            /*#__PURE__*/ _jsxs("button", {
                type: "button",
                className: "appearance-none font-medium space-x-2 text-left py-1",
                onClick: toggle,
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        style: {
                            transform: isOpen ? "rotate(90deg)" : "",
                            width: "14px",
                            height: "14px",
                            marginBottom: "2px",
                            display: "inline"
                        }
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "[&>*]:inline",
                        children: heading
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                style: {
                    display: isOpen ? "block" : "none",
                    paddingLeft: pl
                },
                className: "whitespace-pre-wrap leading-relaxed",
                children: content
            })
        ]
    }));
}
function Icon(props) {
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M8 5v14l11-7z"
        })
    }));
}

;// CONCATENATED MODULE: ../beskar/src/landing/Input.tsx





var Input = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef(function Input(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, _label = _param.label, label = _label === void 0 ? "" : _label, _description = _param.description, description = _description === void 0 ? "" : _description, _errorMessage = _param.errorMessage, errorMessage = _errorMessage === void 0 ? "" : _errorMessage, rest = _object_without_properties(_param, [
        "className",
        "label",
        "description",
        "errorMessage"
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-3",
        children: [
            label && /*#__PURE__*/ _jsx("label", {
                className: "block font-medium opacity-60",
                children: label
            }),
            description && /*#__PURE__*/ _jsx("label", {
                className: "block font-medium text-sm opacity-50",
                children: description
            }),
            /*#__PURE__*/ _jsx("input", _object_spread({
                ref: ref,
                type: "text",
                style: {},
                className: clsx("w-full text-gray-900 rounded-lg p-2 px-3 transition-shadow font-medium tracking-wide", "border-gray-300 block bg-gray-50 focus:ring-2 ring-gray-300 dark:ring-gray-600 focus:ring-gray-400", "focus:!outline-none", "dark:text-white dark:placeholder-gray-400", "dark:focus:ring-gray-500 ring-1 ", "dark:border-gray-600 dark:bg-gray-700", className)
            }, rest)),
            errorMessage && /*#__PURE__*/ _jsx("div", {
                className: "font-medium text-sm dark:text-red-300 text-red-500",
                children: errorMessage
            })
        ]
    });
})));

// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(61706);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(29859);
// EXTERNAL MODULE: ../node_modules/.pnpm/tslib@2.4.1/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(98725);
;// CONCATENATED MODULE: ../beskar/src/landing/GoogleLoginButton.tsx











function GoogleLoginButton(_param) {
    var tmp = _param.callbackPath, callbackUrl = tmp === void 0 ? "/dashboard" : tmp, _className = _param.className, className = _className === void 0 ? "" : _className, _text = _param.text, text = _text === void 0 ? "Continue with Google" : _text, _showEmailSignIn = _param.showEmailSignIn, showEmailSignIn = _showEmailSignIn === void 0 ? false : _showEmailSignIn, _fingerprint = _param.fingerprint, fingerprint = _fingerprint === void 0 ? "" : _fingerprint, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _textColor = _param.textColor, textColor = _textColor === void 0 ? "white" : _textColor, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "callbackPath",
        "className",
        "text",
        "showEmailSignIn",
        "fingerprint",
        "disabled",
        "textColor"
    ]);
    var ref = (0,next_auth_react.useSession)(), session = ref.data;
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("flex flex-col"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    bg: "blue.500",
                    bgDark: "blue.500",
                    biggerOnHover: true,
                    className: (0,clsx_m/* default */.Z)("!px-5 text-white w-full", !disabled && "hover:bg-blue-300", className),
                    style: {
                        minWidth: text.length + 2 + "ch"
                    },
                    disabled: disabled,
                    isLoading: isLoading,
                    "aria-label": "login with google",
                    // bg='#0597FF'
                    onClick: /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    setIsLoading(true);
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        ,
                                        3,
                                        4
                                    ]);
                                    return [
                                        4,
                                        (0,next_auth_react.signIn)("google", {
                                            callbackUrl: new URL(callbackUrl, window.location.href).toString()
                                        }, {
                                            prompt: "select_account"
                                        })
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 3:
                                    setIsLoading(false);
                                    return [
                                        7
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })
                }, rest), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("tracking-wide space-x-2 justify-center items-center font-bold", "flex-row flex"),
                        style: {
                            color: textColor
                        },
                        children: disabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "",
                            children: "Logged in"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleIcon, {
                                    className: "block w-5 h-5 fill-current"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "truncate",
                                    children: text
                                })
                            ]
                        })
                    })
                })),
                showEmailSignIn && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    onClick: function onClick() {
                        (0,next_auth_react.signIn)(undefined, {
                            callbackUrl: callbackUrl
                        });
                    },
                    className: "w-full text-center md:text-left appearance-none underline font-medium opacity-50 active:opacity-30 text-sm mt-3"
                }, rest), {
                    children: "Continue with email instead"
                })),
                fingerprint && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "opacity-60 text-sm font-medium mt-3 w-full text-left",
                    children: fingerprint
                })
            ]
        })
    });
}
function GoogleIcon(_param) {
    var rest = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        viewBox: "0 0 30 30"
    }, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M 15.003906 3 C 8.3749062 3 3 8.373 3 15 C 3 21.627 8.3749062 27 15.003906 27 C 25.013906 27 27.269078 17.707 26.330078 13 L 25 13 L 22.732422 13 L 15 13 L 15 17 L 22.738281 17 C 21.848702 20.448251 18.725955 23 15 23 C 10.582 23 7 19.418 7 15 C 7 10.582 10.582 7 15 7 C 17.009 7 18.839141 7.74575 20.244141 8.96875 L 23.085938 6.1289062 C 20.951937 4.1849063 18.116906 3 15.003906 3 z"
        })
    }));
}

;// CONCATENATED MODULE: ../beskar/src/landing/FeedbackWithCrisp.tsx






function FeedbackWithCrisp(_param) {
    var children = _param.children, useDefaultComponent = _param.useDefaultComponent, _className = _param.className, className = _className === void 0 ? "" : _className, rest = (0,src_object_without_properties/* default */.Z)(_param, [
        "children",
        "useDefaultComponent",
        "className"
    ]);
    if (useDefaultComponent) {
        children = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
            ghost: true,
            children: "Feedback"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        onClick: function onClick() {
            if (typeof $crisp === "undefined") {
                console.warn("FeedbackWithCrisp has not found $crisp variable");
                return;
            }
            $crisp.push([
                "set",
                "message:text",
                [
                    "Hi! I have some feedback: "
                ], 
            ]);
            // $crisp.push(["set", "session:data", [[["user-bill-amount", "$200"]]]]);
            $crisp.push([
                "set",
                "session:event",
                [
                    [
                        [
                            "feedback"
                        ]
                    ]
                ]
            ]);
            $crisp.push([
                "do",
                "chat:open"
            ]);
        },
        className: (0,clsx_m/* default */.Z)("", className)
    }, rest), {
        children: children
    }));
}

;// CONCATENATED MODULE: ../beskar/src/landing/FeaturesBlocks.tsx




function FeaturesBlocks(param) {
    var _style = param.style, style = _style === void 0 ? {} : _style, features = param.features, _className = param.className, className = _className === void 0 ? "" : _className, _blocksClassName = param.blocksClassName, blocksClassName = _blocksClassName === void 0 ? "" : _blocksClassName;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(landing_PageContainer/* PageContainer */._, {
        className: className,
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "py-12",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Faded */.A, {
                delay: 500,
                cascade: true,
                className: (0,clsx_m/* default */.Z)("justify-center grid gap-12 xl:grid-cols-3 xl:gap-28", "sm:grid-cols-2 md:justify-start md:gap-16"),
                children: features.map(function(feature, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex space-x-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)("w-14 shadow-lg rounded-lg opacity-90", "justify-center items-center h-14 flex-shrink-0", "flex md:rounded-xl", blocksClassName),
                                    children: feature.Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(feature.Icon, {
                                        className: "w-6 font-bold h-6"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "space-y-1",
                                    children: [
                                        feature.bullet && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)("tracking-wider rounded px-1 mb-1 max-w-max", "font-semibold dark:bg-gray-800 bg-gray-100 text-[10px]", "py-[2px] -mt-[2.1em]"),
                                            children: feature.bullet
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-lg font-semibold md:text-xl",
                                            children: feature.heading
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-sm opacity-60",
                                            children: feature.description
                                        })
                                    ]
                                })
                            ]
                        })
                    }, i);
                })
            })
        })
    });
}

;// CONCATENATED MODULE: ../beskar/src/landing/index.tsx





























/***/ })

}]);